import type { AppraisalPaymentReminderSummary } from '../../../../../supabase/functions/_shared/appraisal-workspace-contract';

export type FormatDate = (value: string | null | undefined, includeTime?: boolean) => string;

/** The last reminder for a link in one line: the loan's Payment link panel and the Payment links report. */
export function reminderLine(
  request: { lastReminder: Pick<AppraisalPaymentReminderSummary, 'status' | 'createdAt' | 'sentAt' | 'senderName'> | null },
  formatDate: FormatDate
): string {
  const reminder = request.lastReminder;
  if (!reminder) {
    return 'None sent yet';
  }
  const by = reminder.senderName ? ` by ${reminder.senderName}` : '';
  if (reminder.status === 'sent') {
    return `Sent ${formatDate(reminder.sentAt || reminder.createdAt, true)}${by}`;
  }
  if (reminder.status === 'failed') {
    return `Not sent ${formatDate(reminder.createdAt, true)}${by}`;
  }
  if (reminder.status === 'sending') {
    return `Sending since ${formatDate(reminder.createdAt, true)}${by}`;
  }
  return `Unconfirmed since ${formatDate(reminder.createdAt, true)}${by}. Check Email Notifications before sending again.`;
}
